export default (state = {}) => {
  return {
    ...state,
    currentPath: null,
    currentScreen: null,
    currentScreenParams: null,
  };
};
